import { post } from '../../Services/http';
import { catchError } from '../../Actions/Error.action';
import { translate } from '../../Services/translation';

export const NEWSLETTER_SET_STATUS = "NEWSLETTER_SET_STATUS";
export const NEWSLETTER_TOGGLE_ERROR_MESSAGE = "NEWSLETTER_TOGGLE_ERROR_MESSAGE";
export const NEWSLETTER_ERROR = "NEWSLETTER_ERROR";

export const sendLetterRequest = (email) => (dispatch, getState) => {
    return post('/api/newslettersignup', { email })
        .then(response => response.json())
        .then(response => dispatch(newsletterSentMessage(response, email)))
        .catch(ex => dispatch(catchError(ex, error => setError(error))));
}

export const newsletterSentMessage = (response, email) => (dispatch, getState) => {

    if (!response) {
        dispatch(toggleErrorMessage(translate("common.newsletter.signup.alert.error"), true));
        return;
    }

    var cookie = (document.cookie.match(/^(?:.*;)?\s*cookie_consent2\s*=\s*([^;]+)(?:.*)?$/) || [, null])[1];
    if (cookie && cookie.indexOf('marketing') >= 0) {
        var _learnq = _learnq || [];
        _learnq.push([
            'identify', {
                '$email': email
            }
        ]);
    }

    dispatch({
        type: NEWSLETTER_SET_STATUS, 
        payload: {
            subscriptionSuccess: true,
        }
    });
   
}

export const toggleErrorMessage = (message, isShowing) => (dispatch, getState) => {
    dispatch({
        type: NEWSLETTER_TOGGLE_ERROR_MESSAGE,
        payload: {
            errorMessage: message,
            showErrorText: isShowing
        }
    });
}

export const setError = error => ({
    type: NEWSLETTER_ERROR,
    payload: {
        error,
    },
})
